import moment from 'moment';
import React, { useCallback, useRef } from 'react';

import { optionsValues } from '../consts/options';
import SelectCustom from '../../../../SelectCustom';
import { useLabTestHistoryContext } from '../state/context';
import HealthRecordSearch from '../../DataList/HealthRecordSearch';
import { API_DATE_FORMAT } from '../../../../../utils/schedule/date-formatter';

import styles from './index.styl';

export const LabTestHistorySelector = () => {
  const {
    option,
    pending,
    endDate,
    setOption,
    startDate,
    setEndDate,
    setStartDate,
    formatMessage,
  } = useLabTestHistoryContext();

  const fetchData = useCallback(() => {
    if (startDate && endDate) {
      setStartDate(moment(startDate).format(API_DATE_FORMAT));
      setEndDate(moment(endDate).format(API_DATE_FORMAT));
    }
  }, [startDate, endDate]);

  const clearDate = () => {
    setEndDate('');
    setStartDate('');
  };

  const msg = useRef({
    range: formatMessage({
      id: 'patient.healthboard.labTestHistory.range',
    }),
    ten: formatMessage({
      id: 'patient.healthboard.labTestHistory.selector.ten',
    }),
    all: formatMessage({
      id: 'patient.healthboard.labTestHistory.selector.all',
    }),
    five: formatMessage({
      id: 'patient.healthboard.labTestHistory.selector.five',
    }),
    custom: formatMessage({
      id: 'patient.healthboard.labTestHistory.selector.custom',
    }),
  });

  const options = [
    { value: optionsValues.FIVE, label: msg.current.five },
    { value: optionsValues.TEN, label: msg.current.ten },
    { value: optionsValues.ALL, label: msg.current.all },
    { value: optionsValues.CUSTOM, label: msg.current.custom },
  ];

  return (
    <div className={styles.wrapper}>
      <div className={styles.selectorWrapper}>
        <div className={styles.selectorLabel}>{msg.current.range}</div>
        <SelectCustom
          options={options}
          defaultValue={option}
          className={styles.selector}
          placeholder={msg.current.five}
          onChange={e => setOption(e.value)}
        />
      </div>

      {option === optionsValues.CUSTOM && (
        <div className={styles.ranger}>
          <HealthRecordSearch
            pending={pending}
            endDate={endDate}
            onClear={clearDate}
            startDate={startDate}
            setEndDate={setEndDate}
            setStartDate={setStartDate}
            onSearch={() => fetchData()}
            formatMessage={formatMessage}
          />
        </div>
      )}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/LabTestHistoryModal/LabTestHistorySelector/index.jsx